"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NearestMode = exports.getIndexNearest = void 0;
var NearestMode;
(function (NearestMode) {
    NearestMode[NearestMode["DELTA"] = 0] = "DELTA";
    NearestMode[NearestMode["OVER"] = 1] = "OVER";
})(NearestMode || (NearestMode = {}));
exports.NearestMode = NearestMode;
var getIndexNearest = function (dataPointGroup, thickness, cursorX, cursorY, mode) {
    if (mode === void 0) { mode = NearestMode.DELTA; }
    var deltas = dataPointGroup[0].map(function (it) { return [it[0] + thickness / 2, it[1]]; }).map(function (it) { return Math.abs(it[0] - (cursorX || 0)); });
    var min = Math.min.apply(Math, deltas);
    var indexX = deltas.indexOf(min);
    var nearestX = dataPointGroup[0][indexX];
    var indexY = 0;
    var nearestY = dataPointGroup[0][indexX];
    if (cursorY) {
        if (mode === NearestMode.DELTA) {
            var delta = dataPointGroup.map(function (it) { return Math.abs(cursorY - it[indexX][1]); });
            indexY = delta.indexOf(Math.min.apply(Math, delta));
        }
        else {
            indexY = dataPointGroup.map(function (it) { return it[indexX][1]; }).findIndex(function (it) { return cursorY > it; });
            indexY = indexY === -1 ? dataPointGroup.length - 1 : indexY;
        }
        nearestY = dataPointGroup[indexY][indexX];
    }
    return { indexX: indexX, nearestX: nearestX, indexY: indexY, nearestY: nearestY };
};
exports.getIndexNearest = getIndexNearest;
